module.exports = __webpack_public_path__ + "media/SuiteApp/assets/svg/img/share_li-479a7f9fd4d5cc55819381dfca12008c.svg";